<template>
  <div
    @click.self="close"
    class="modal show"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" style="max-width:600px" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Удаление расписания
          </h5>
        </div>
        <div class="modal-body">
          <div class="doctor">
            <div class="subtitle">
              {{ doctor.department }} / {{ doctor.specialty }}
            </div>
            <div class="title">{{ doctor.name }}</div>
          </div>
          <form>
            <div class="dates" style="display:flex; justify-content: space-between">
             
                <b-calendar
                  :start-weekday="1"
                  :date-format-options="dateFormatOptions"
                  :max="endDate"
                  placeholder="Начало"
                  v-model="startDate"
                  style="text-align:center"
                >Начало</b-calendar>
                <b-calendar
                  :start-weekday="1"
                  :date-format-options="dateFormatOptions"
                  :min="startDate"
                  placeholder="Конец"
                  v-model="endDate"
                  style="text-align:center"
                >Конец</b-calendar>
              
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <b-button variant="danger" @click="submit()">
            Очистить
          </b-button>
          <b-button variant="outline-primary" @click="close()">
            Отменить
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    doctor: Object
  },
  data() {
    return {
      dateFormatOptions: { year: 'numeric', month: 'numeric', day: 'numeric' },
      startDate: null,
      endDate: null
    };
  },
  methods: {
    async submit() {
      const format = n => (n > 9 ? '' + n : '0' + n);
      const hourOffsetUTC =
        '+' + format(-new Date().getTimezoneOffset() / 60) + ':00';
      const payload = {
        UTC: hourOffsetUTC,
        debug: false,
        doctor: this.doctor.id,
        dates: {
          start: this.startDate,
          end: this.endDate
        }
      };
      this.$emit('success', payload);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
}
.modal-body {
  padding: 0 15px 0 15px;
  margin: 0;
}
.doctor {
  margin-bottom: 24px;
}
.doctor .title {
  font-size: 1.4rem;
  line-height: 1;
}
.doctor .subtitle {
  font-size: 0.9rem;
  color: #616161;
  font-weight: 300;
}
.input-group,
.btn-group,
.input-group > *,
.btn-group > * {
  position: static;
  z-index: auto;
}
.dates,
.days,
.time-ranges {
  margin-bottom: 12px;
}
.time-ranges .range {
  margin-top: 6px;
}
.delay {
  margin-bottom: 12px;
}
.btn-primary:focus,
.btn-outline-primary:focus {
  box-shadow: none;
}
.btn-outline-primary:hover {
  color: #007bff;
  background-color: #fff;
}
::v-deep .dropdown.show {
  z-index: 99999;
}
</style>
